// Safely serialize a JSON-LD object for injection via dangerouslySetInnerHTML.
// Escapes every "<" -> "\\u003c" (defence-in-depth: prevents premature
// </script> termination and any other tag-injection edge case, even if a
// schema value ever contains "<"). Content is otherwise trusted (it's our
// own compiled schema, never user input).
export function safeJsonLd(obj) {
  return JSON.stringify(obj).replace(/</g, '\\u003c');
}
